<p-toast key="chat-widget"></p-toast>

<div
  #iconEl
  class="chat-widget-icon"
  [class.chat-widget-icon--hidden]="chat.open()"
  data-testid="chat-widget-icon"
  cdkDrag
  cdkDragBoundary="body"
  cdkDragLockAxis="y"
  [cdkDragDisabled]="chat.open()"
  [cdkDragFreeDragPosition]="iconPosition()"
  (cdkDragEnded)="onIconDragEnded($event)"
  (click)="onIconClick()"
  (keydown.enter)="onIconClick()"
  [attr.aria-label]="'chat_widget.title' | translate"
  role="button"
  tabindex="0"
>
  <i class="pi pi-comments"></i>
</div>

<div
  class="chat-widget-panel"
  [class.chat-widget-panel--open]="chat.open()"
  data-testid="chat-widget-panel"
  [style.top]="panelStyle().top"
  [style.transform-origin]="panelStyle().transformOrigin"
>
  <div class="chat-widget-header">
    @if (historyOpen()) {
      <span class="chat-widget-header-title">
        <button
          type="button"
          class="chat-widget-close chat-widget-back"
          data-testid="chat-widget-history-back"
          [attr.aria-label]="'chat_widget.history.back' | translate"
          [title]="'chat_widget.history.back' | translate"
          (click)="historyOpen.set(false)"
        >
          <i class="pi pi-arrow-left"></i>
        </button>
        {{ 'chat_widget.history.title' | translate }}
      </span>
    } @else {
      <span>{{ 'chat_widget.title' | translate }}</span>
    }
    <span class="chat-widget-header-actions">
      @if (!historyOpen()) {
        <button
          type="button"
          class="chat-widget-close"
          data-testid="chat-widget-history-open"
          [attr.aria-label]="'chat_widget.history.title' | translate"
          [title]="'chat_widget.history.title' | translate"
          (click)="openHistory()"
        >
          <i class="pi pi-history"></i>
        </button>
      }
      @if (chat.hasMessages() && !historyOpen()) {
        <button
          type="button"
          class="chat-widget-close"
          data-testid="chat-widget-new-conversation"
          [attr.aria-label]="'chat_widget.newConversation' | translate"
          [title]="'chat_widget.newConversation' | translate"
          [disabled]="chat.busy()"
          (click)="startNewConversation()"
        >
          <i class="pi pi-pen-to-square"></i>
        </button>
      }
      <button
        type="button"
        class="chat-widget-close"
        data-testid="chat-widget-close"
        [attr.aria-label]="'chat_widget.close' | translate"
        (click)="chat.close()"
      >
        <i class="pi pi-times"></i>
      </button>
    </span>
  </div>

    @if (historyOpen()) {
      <div class="chat-widget-history" data-testid="chat-widget-history">
        @if (chat.conversations().length === 0) {
          @if (chat.conversationsLoading()) {
            <div class="chat-widget-loading" data-testid="chat-widget-history-loading">...</div>
          } @else if (!chat.conversationsError()) {
            <p class="chat-widget-empty" data-testid="chat-widget-history-empty">{{ 'chat_widget.history.empty' | translate }}</p>
          }
        }
        @for (group of conversationGroups(); track group.key) {
          <div class="chat-widget-history-group">{{ 'chat_widget.history.groups.' + group.key | translate }}</div>
          @for (conversation of group.conversations; track conversation.conversationId) {
            <button
              type="button"
              class="chat-widget-history-item"
              [class.chat-widget-history-item--active]="conversation.conversationId === chat.conversationId()"
              [attr.data-testid]="'chat-widget-history-item-' + conversation.conversationId"
              [disabled]="chat.busy()"
              (click)="selectConversation(conversation.conversationId)"
            >
              <span class="chat-widget-history-item-title">{{ conversation.title || ('chat_widget.history.untitled' | translate) }}</span>
              <span class="chat-widget-history-item-time">
                {{ conversation.lastActivityAt | date: (group.key === 'today' || group.key === 'yesterday' ? 'HH:mm' : 'dd/MM/yyyy') }}
              </span>
            </button>
          }
        }
        @if (chat.conversationsError()) {
          <p class="chat-widget-error" data-testid="chat-widget-history-error">
            {{ 'chat_widget.history.error' | translate }}
            <button type="button" class="chat-widget-history-more" data-testid="chat-widget-history-retry" (click)="retryConversations()">
              {{ 'chat_widget.history.retry' | translate }}
            </button>
          </p>
        } @else if (chat.hasMoreConversations()) {
          <button
            type="button"
            class="chat-widget-history-more"
            data-testid="chat-widget-history-more"
            [disabled]="chat.conversationsLoading()"
            (click)="chat.loadConversations(true)"
          >
            {{ (chat.conversationsLoading() ? 'chat_widget.history.loading' : 'chat_widget.history.loadMore') | translate }}
          </button>
        }
      </div>
    }

    <div
      #messagesEl
      class="chat-widget-messages"
      [class.chat-widget-hidden]="historyOpen()"
      data-testid="chat-widget-messages"
      (scroll)="onMessagesScroll(messagesEl)"
    >
      @if (openedFromHistory() && !chat.historyLoading()) {
        <p class="chat-widget-history-note" data-testid="chat-widget-history-note">{{ 'chat_widget.history.staleNote' | translate }}</p>
      }
      @if (chat.historyLoading()) {
        <div class="chat-widget-loading">...</div>
      }
      @if (!chat.historyLoading() && !chat.hasMessages()) {
        <p class="chat-widget-empty">{{ 'chat_widget.empty' | translate }}</p>
      }
      @for (message of chat.messages(); track $index) {
        <div
          class="chat-widget-message"
          [class.chat-widget-message--user]="message.role === 'user'"
          [class.chat-widget-message--wide]="isWideMessage(message, $index)"
        >
          <p #textEl class="chat-widget-message-text" [innerHTML]="message.text | chatFormat"></p>
          <ng-template #cardTpl let-card>
            <div class="chat-widget-card" data-testid="chat-widget-card">
              <button
                type="button"
                class="chat-widget-card-view"
                data-testid="chat-widget-card-view"
                (click)="openProduct(card.skuCode)"
              >
                <span class="chat-widget-card-name" [title]="card.name">{{ card.name }}</span>
                <span class="chat-widget-card-sku">SKU: {{ card.skuCode }}</span>
                <span class="chat-widget-card-price">{{ card.salesPrice | number: '1.0-0' }}đ</span>
                @if (card.availableStock != null) {
                  <span
                    class="chat-widget-card-stock"
                    [class.chat-widget-card-stock--out]="card.availableStock <= 0"
                    data-testid="chat-widget-card-stock"
                  >
                    {{ 'chat_widget.availableStock' | translate: { count: (card.availableStock | number: '1.0-0') } }}
                  </span>
                }
              </button>
              <button
                type="button"
                class="chat-widget-card-edit"
                data-testid="chat-widget-card-edit"
                [attr.aria-label]="'sku_management.actions.edit' | translate"
                (click)="editProduct(card.skuCode, $event)"
              >
                <i class="pi pi-pencil"></i>
              </button>
            </div>
          </ng-template>
          @if (message.productGroups && message.productGroups.length > 0) {
            @for (group of message.productGroups; track group.category) {
              <div class="chat-widget-card-group" data-testid="chat-widget-card-group">
                <div class="chat-widget-card-group-label">{{ group.category }}</div>
                <div class="chat-widget-cards">
                  @for (card of group.products; track card.skuCode) {
                    <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: card }"></ng-container>
                  }
                </div>
              </div>
            }
          } @else if (message.products && message.products.length > 0) {
            <div class="chat-widget-cards">
              @for (card of message.products; track card.skuCode) {
                <ng-container *ngTemplateOutlet="cardTpl; context: { $implicit: card }"></ng-container>
              }
            </div>
          }
        </div>
      }
      @if (followUps().length > 0) {
        <div class="chat-widget-followups" data-testid="chat-widget-followups">
          @for (suggestion of followUps(); track suggestion.id) {
            <button
              type="button"
              class="chat-widget-suggestion"
              [attr.data-testid]="'chat-widget-followup-' + suggestion.id"
              (click)="useSuggestion(suggestion)"
            >
              {{ suggestion.key | translate: suggestion.params }}
            </button>
          }
        </div>
      }
      @if (chat.sending()) {
        <div class="chat-widget-typing" role="status" [attr.aria-label]="'chat_widget.typing' | translate" data-testid="chat-widget-typing">
          <span class="chat-widget-typing-dot"></span>
          <span class="chat-widget-typing-dot"></span>
          <span class="chat-widget-typing-dot"></span>
        </div>
      }
      @if (chat.error()) {
        <p class="chat-widget-error">{{ 'chat_widget.error' | translate }}</p>
      }
    </div>

    @if (showSuggestions() && !chat.hasMessages() && !historyOpen()) {
      <div class="chat-widget-suggestions" data-testid="chat-widget-suggestions">
        @for (suggestion of suggestions(); track suggestion.id) {
          <button
            type="button"
            class="chat-widget-suggestion"
            [attr.data-testid]="'chat-widget-suggestion-' + suggestion.id"
            [disabled]="chat.sending()"
            (click)="useSuggestion(suggestion)"
          >
            {{ suggestion.key | translate: suggestion.params }}
          </button>
        }
      </div>
    }

    <form class="chat-widget-input-row" [class.chat-widget-hidden]="historyOpen()" (submit)="submit($event)">
      <input
        #inputEl
        type="text"
        data-testid="chat-widget-input"
        class="chat-widget-input"
        [ngModel]="draft()"
        (ngModelChange)="draft.set($event)"
        name="chatDraft"
        [placeholder]="'chat_widget.placeholder' | translate"
        [disabled]="chat.sending()"
      />
      <button
        type="submit"
        data-testid="chat-widget-send"
        class="chat-widget-send"
        [disabled]="chat.sending() || !draft().trim()"
      >
        <i class="pi pi-send"></i>
      </button>
    </form>
</div>
